import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-checking-account-detail-with-schedules-delete',
    template: require('./checkingAccountDetailsWithSchedulesDialogDelete.html')
})
export class CheckingAccountDetailsWithSchedulesDeleteDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<CheckingAccountDetailsWithSchedulesDeleteDialog>) public dialogRef: MatDialogRef<CheckingAccountDetailsWithSchedulesDeleteDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
